import {adicRestApi, adicRestApiThemeUrl} from "@common/services/restapi";

export const getThemeList = async (isSummary, pageNumber, pageSize) => {
  const url = adicRestApiThemeUrl
    .segment("/theme/list")
    .query(isSummary, pageNumber, pageSize)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getThemeAdList = async (id, pageNumber, pageSize) => {
  if (!id) return {};
  const url = adicRestApiThemeUrl
    .segment("/theme/ad-list")
    .query(id, pageNumber, pageSize)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
